import { render } from "./QywxChatKeyWords.vue?vue&type=template&id=565f4930"
import script from "./QywxChatKeyWords.vue?vue&type=script&lang=js"
export * from "./QywxChatKeyWords.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/ai/chatKeyWord/QywxChatKeyWords.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "565f4930"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('565f4930', __exports__)) {
    api.reload('565f4930', __exports__)
  }
  
  module.hot.accept("./QywxChatKeyWords.vue?vue&type=template&id=565f4930", () => {
    api.rerender('565f4930', render)
  })

}


export default __exports__